export default __webpack_public_path__ + "static/media/angelo-pantazis.f2ff311c.jpg";